import React from 'react';
import { Stack } from '../Stack/Stack';
import { FormSelect } from '../Form/Select/FormSelect';
import { Icon } from '../Icon/Icon';
import { t } from '../../locales/translate';
import classnames from 'classnames';
import { Writeable } from '../../util/util';
import './cursor_pagination.css';

const pageSizes = ['10', '20', '50', '100'] as const;
export type RowsPerPage = Writeable<(typeof pageSizes)[number]>;
export const rowsPerPageOptions = pageSizes.map((value) => ({ value }));

interface Props {
  rowsPerPage?: RowsPerPage;
  onFirstPageClick?: () => void;
  onNextPageClick?: () => void;
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
  onRowsPerPageChange?: (rows: RowsPerPage) => void;
}

export function CursorPagination({
  rowsPerPage = rowsPerPageOptions[1].value,
  onFirstPageClick,
  onNextPageClick,
  hasNextPage,
  hasPreviousPage,
  onRowsPerPageChange,
}: Props): JSX.Element {
  return (
    <div className="cursor-pagination">
      <Stack line size="lg">
        <Stack line size="xs">
          <p>{t.general.rowsPerPage}</p>
          <FormSelect
            options={rowsPerPageOptions}
            value={rowsPerPage}
            compact
            widthAuto
            onChange={(value) => {
              if (value) onRowsPerPageChange?.(value);
            }}
          />
        </Stack>
        <Stack line size="xxs">
          <Icon
            onClick={() => onFirstPageClick?.()}
            disabled={!hasPreviousPage}
            name="arrow-left-start"
            className={classnames('cursor-pagination__icon')}
          />
          <Icon
            onClick={() => onNextPageClick?.()}
            disabled={!hasNextPage}
            name="arrow-right--sm"
            className={classnames('cursor-pagination__icon')}
          />
        </Stack>
      </Stack>
    </div>
  );
}
